import { render, staticRenderFns } from "./fsa-overview-bucket.component.vue?vue&type=template&id=3459ebeb&"
import script from "./fsa-overview-bucket.component.vue?vue&type=script&lang=ts&"
export * from "./fsa-overview-bucket.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports